import { cn } from "@theprelude/core";

export const EntraIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.5672 13.3415L13.5552 1.70169C13.1547 1.2339 12.5807 1 12.02 1C11.4594 1 10.8853 1.2339 10.4849 1.70169L0.472876 13.3415C-0.301384 14.2358 -0.101144 15.5979 0.900053 16.2445C0.900053 16.2445 4.61116 18.6248 5.07838 18.9275L10.912 22.6836C11.2458 22.9037 11.6329 23 12.0067 23V17.4003L6.18638 13.6442L12.0067 6.87492L17.827 13.6442L11.9933 17.4003V23C12.3805 23 12.7542 22.8899 13.088 22.6836L23.0999 16.2308C24.1011 15.5841 24.3014 14.222 23.5271 13.3277L23.5672 13.3415Z" />
  </svg>
);
